import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import JobCard from '@/partials/JobCards/JobCard/JobCard.vue'

const SORT_NEW = {
  name: 'Newest',
  field: 'date',
  dir: 'desc',
}

const SORT_OLD = {
  name: 'Oldest',
  field: 'date',
  dir: 'asc',
}

const SORT_OPTIONS = [SORT_NEW, SORT_OLD]

const BOOKMARKS_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    JobCard,
    InfiniteLoading,
  },
  data() {
    return {
      infiniteId: 0,
      totalLoading: false,
      sortValue: SORT_NEW,
      sortOptions: SORT_OPTIONS,
    }
  },
  computed: {
    ...mapState({
      bookmarks: (state: any) => state.bookmarks?.jobBookmarks.values,
      isLoading: (state: any) => state.bookmarks?.jobBookmarks.isLoading,
      isLoaded: (state: any) => state.bookmarks?.jobBookmarks.isLoaded,
      pagination: (state: any) => state.bookmarks?.jobBookmarks.pagination,
    }),
  },
  async created() {
    await this.load({
      limit: BOOKMARKS_LIMIT,
      offset: 0,
      orderField: this.sortValue.field,
      orderType: this.sortValue.dir,
    })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'bookmarks/loadJobBookmarks',
      loadMore: 'bookmarks/loadMoreJobBookmarks',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.bookmarks.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({
            limit: BOOKMARKS_LIMIT,
            offset: this.bookmarks.length,
            orderField: this.sortValue.field,
            orderType: this.sortValue.dir,
          })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
    async onSortInput(sort: any) {
      if (sort && sort?.name !== this.sortValue?.name) {
        this.sortValue = sort
        await this.load({
          limit: BOOKMARKS_LIMIT,
          offset: 0,
          orderField: this.sortValue.field,
          orderType: this.sortValue.dir,
        })
        this.infiniteId = +new Date()
      }
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('Bookmarks - Jobs'),
    }
  },
})
